import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const AboutUs = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.about.title}
            </h2>
          </div>

          {/* Mission */}
          <div className="mb-16 bg-white p-8 md:p-12 rounded-2xl shadow-lg">
            <h3 className="text-3xl font-bold text-orange-600 mb-6">
              {t.about.mission.title}
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t.about.mission.description}
            </p>
          </div>

          {/* Why Space Data */}
          <div className="bg-gray-900 text-white p-8 md:p-12 rounded-2xl shadow-lg">
            <h3 className="text-3xl font-bold text-orange-400 mb-6">
              {t.about.why.title}
            </h3>
            <p className="text-lg text-gray-200 leading-relaxed">
              {t.about.why.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
